export default __webpack_public_path__ + "static/media/LinkedIn-Elogiar-Reconhecer-Colega-08.a0276512.jpg";